import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel';
import React from 'react';

const RightSideLayout2 = () => {
	return (
		<>
			<QuickPanel />
		</>
	);
};

export default React.memo(RightSideLayout2);
